module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Groups"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half-desktop is-offset-one-quarter-desktop"
  }, [_c('LinkTab', {
    attrs: {
      "tabs": _vm.tabs
    }
  }), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7a4defc4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupBase.vue
// module id = 1069
// module chunks = 0